import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { environment } from '@orion/environment';
import { SetLanguage, SetupLanguage } from './language.actions';
import { defaultState } from './language.consts';
import { LanguageStateModel } from './language.types';

@State<LanguageStateModel>({
  defaults: defaultState,
  name: 'language',
})
@Injectable()
export class LanguageState {
  @Action(SetupLanguage)
  setupLang({ setState }: StateContext<LanguageStateModel>, { defaultLang }: SetupLanguage): void {
    setState({
      currentLang: defaultLang,
      defaultLang,
      languages: environment.language.languages,
    });
  }

  @Action(SetLanguage)
  setLang({ patchState }: StateContext<LanguageStateModel>, { language }: SetLanguage): void {
    patchState({
      currentLang: language,
    });
  }
}
